import React from 'react';

import * as styles from './Breadcrumbs.module.scss';

export const Breadcrumbs = ({ breadcrumbs }: { breadcrumbs: { href: string; text: string }[] }) => {
  return (
    <div className={styles.root}>
      {breadcrumbs.map((breadcrumb, index) => (
        <span className={styles.item} key={breadcrumb.href}>
          {breadcrumb.href ? <a href={breadcrumb.href}>{breadcrumb.text}</a> : <span>{breadcrumb.text}</span>}
          {index < breadcrumbs.length - 1 && (
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path
                d="M10.0007 7.99992L7.33398 5.33325"
                stroke="#A0AEC0"
                strokeWidth="1.33333"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M7.33398 10.6667L10.0007 8"
                stroke="#A0AEC0"
                strokeWidth="1.33333"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </span>
      ))}
    </div>
  );
};
